import React from 'react';
import { Paper, Typography, Divider, Grid } from '@mui/material';

/**
 * Mirrors "DETAILS OF THE NEXT MEETING" from the printed form. This section
 * did not exist at all in the previous PerformanceAnalysis.js / Summary.js.
 *
 * nextMeeting shape (field names are a best guess - adjust to match
 * whatever the backend actually returns, e.g. on currentPeriod or group):
 *   date         - date of next meeting
 *   time         - meeting time
 *   venue        - meeting venue
 *   contactPhone - telephone number of contact person
 */
const NextMeetingDetails = ({ nextMeeting }) => {
  const m = nextMeeting || {};

  return (
    <Paper sx={{ p: 2, mt: 3 }} data-testid="next-meeting-details">
      <Typography variant="h6" gutterBottom color="primary">
        DETAILS OF THE NEXT MEETING
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" color="text.secondary">
            Date of Next Meeting
          </Typography>
          <Typography variant="body1">{m.date || 'N/A'}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" color="text.secondary">
            Time
          </Typography>
          <Typography variant="body1">{m.time || 'N/A'}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" color="text.secondary">
            Venue for Next Meeting
          </Typography>
          <Typography variant="body1">{m.venue || 'N/A'}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" color="text.secondary">
            Telephone Number of Contact Person
          </Typography>
          <Typography variant="body1">{m.contactPhone || 'N/A'}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default NextMeetingDetails;